import en from '@/i18n/en';
import uk from '@/i18n/uk';
import { createI18n } from 'vue-i18n';

const i18n = createI18n({
  legacy: false,
  locale: 'en',
  messages: {
    en,
    uk,
  },
});

export default i18n;
